// extracted by css-extract-rspack-plugin
export default {"cls1":"Tabs-cls1_RwM","cls2":"Tabs-cls2_u_x Tabs-cls1_RwM","active":"Tabs-active_W-h"};